import * as React from 'react';
import Arrow from '../../../../../common/designElements/Arrows';

interface RequestQuoteProps {
    isRequested?: boolean;
    onBack?: () => void;
    onClose: () => void;
    updatePrice?: (data: any) => Promise<any>;
    // currentProject: Project;
    // onClose: () => void;
    // changePath: (path: string) => void;
}

const RequestQuote: React.FunctionComponent<RequestQuoteProps> = (
    props: RequestQuoteProps
) => {
    const [isSubmitted, setIsSubmitted] = React.useState(props.isRequested);

    const onSubmitRequest = async () => {
        await props.updatePrice({ quoteRequested: true });
        setIsSubmitted(true);
    };

    if (isSubmitted) {
        return (
            <React.Fragment>
                <p className="price--modal--title">
                    Request has been submitted
                </p>
                <p className="price--modal--subtitle">
                    We will email the project creator within 24 hours!
                </p>
                <div className="price--modal--footer">
                    <button
                        className="btn btn--md btn--green"
                        onClick={props.onClose}
                    >
                        Okay
                    </button>
                </div>
            </React.Fragment>
        );
    }
    return (
        <React.Fragment>
            <span className="price--modal--header-back" onClick={props.onBack}>
                <Arrow type="left" /> Back
            </span>
            <p className="price--modal--title">Request a quote</p>
            <p className="price--modal--subtitle">
                Submit a request for a quote and we will get back to you with
                the cost within 24 hours
            </p>
            <div className="price--modal--footer left">
                <button
                    className="btn btn-md btn--blue"
                    onClick={onSubmitRequest}
                >
                    Submit Request
                </button>
            </div>
        </React.Fragment>
    );
};

export default RequestQuote;
